<template>
  <main class="privacy">
    <div class="container">
      <img src="/images/logo-white.svg"
           alt="wifeed logo"
           class="logo">

      <h1 class="privacy-title"
          ref="privacyTitle"></h1>
      <div class="privacy-content"
           ref="privacyContent"></div>
    </div>
  </main>
</template>

<script>
    export default {
        components: {
       
        },

        data() {
            return {

            }
        },

        methods: {
          async loadPrivacy() {
            const privacy = await this.$api.terms.privacy()

            this.$refs.privacyContent.innerHTML = privacy.content
            this.$refs.privacyTitle.innerHTML = privacy.title
          }
        },

        watch: {

        },

        mixins: [],

        computed: {
        },

        mounted() {
          document.getElementsByTagName('html')[0].style = 'overflow-y:scroll;'
          this.loadPrivacy()
        },

        beforeDestroy() {
        }

    }
</script>

<style  lang="scss" scoped>
@import "~@variables";

.privacy {
  background: $primary;
  overflow: auto;

  .container {
    //width: 90%;

    img {
      max-width: 197px;
      margin: 50px auto;
      display: block;
    }

    .privacy-title {
      color: white;
    }

    .privacy-content {
      color: white;
    }
  }
}
</style>



